import QRCode from "qrcode";

// Dreptunghi cu colțuri rotunjite (cu fallback pentru browsere fără roundRect)
const roundRect = (ctx, x, y, w, h, r) => {
  if (ctx.roundRect) {
    ctx.beginPath();
    ctx.roundRect(x, y, w, h, r);
    return;
  }
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
};

/**
 * Construiește o imagine brandată de tip "bilet" cu cod QR de înaltă
 * rezoluție (scanabil) și returnează un data URL PNG.
 *
 * strings: { eventName, invitationPass, dateLabel, eventDate,
 *            locationLabel, eventLocation, ticketPresent }
 */
export async function buildTicketDataUrl(qrData, strings) {
  // QR crisp + scanabil (corecție de erori H, margine = zonă liniștită)
  const qrCanvas = document.createElement("canvas");
  await QRCode.toCanvas(qrCanvas, qrData, {
    width: 520,
    margin: 2,
    errorCorrectionLevel: "H",
    color: { dark: "#0B2A3C", light: "#ffffff" },
  });

  const W = 860;
  const H = 1240;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // fundal
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, W, H);

  // bandă superioară cu gradient
  const band = 240;
  const grad = ctx.createLinearGradient(0, 0, W, band);
  grad.addColorStop(0, "#0066A6");
  grad.addColorStop(1, "#00456f");
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, W, band);

  ctx.textAlign = "center";
  ctx.fillStyle = "#ffffff";
  ctx.font = "bold 60px Aeonik, Arial, sans-serif";
  ctx.fillText(strings.eventName, W / 2, 118);
  ctx.font = "500 26px Aeonik, Arial, sans-serif";
  ctx.fillStyle = "rgba(255,255,255,0.9)";
  ctx.fillText(strings.invitationPass, W / 2, 165);

  // card alb pentru QR
  const qrSize = 520;
  const qrX = (W - qrSize) / 2;
  const qrY = 320;
  ctx.save();
  ctx.shadowColor = "rgba(0,102,166,0.15)";
  ctx.shadowBlur = 30;
  ctx.shadowOffsetY = 10;
  ctx.fillStyle = "#ffffff";
  roundRect(ctx, qrX - 28, qrY - 28, qrSize + 56, qrSize + 56, 32);
  ctx.fill();
  ctx.restore();
  ctx.strokeStyle = "#e6eef5";
  ctx.lineWidth = 2;
  roundRect(ctx, qrX - 28, qrY - 28, qrSize + 56, qrSize + 56, 32);
  ctx.stroke();
  ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);

  // detalii eveniment
  let iy = qrY + qrSize + 110;
  const drawRow = (label, value) => {
    ctx.fillStyle = "#0066A6";
    ctx.font = "bold 24px Aeonik, Arial, sans-serif";
    ctx.fillText(String(label).toUpperCase(), W / 2, iy);
    ctx.fillStyle = "#0B2A3C";
    ctx.font = "600 34px Aeonik, Arial, sans-serif";
    ctx.fillText(value, W / 2, iy + 44);
    iy += 120;
  };
  drawRow(strings.dateLabel, strings.eventDate);
  drawRow(strings.locationLabel, strings.eventLocation);

  // footer
  ctx.fillStyle = "#8aa0b2";
  ctx.font = "500 22px Aeonik, Arial, sans-serif";
  ctx.fillText(strings.ticketPresent, W / 2, H - 46);

  return canvas.toDataURL("image/png");
}
